import { useMemo, type FC } from "react";
import { useRecoilValue } from "recoil";

import {
  RidesAssignDocksButton,
  RidesMapToggleButton,
  RidesNearByButton,
  RidesSelectAllCheckbox,
} from "@ryde/layout";
import { useRidesNavigation } from "@ryde/redux";
import { systemSettingsDtoAtom, useIsMobile } from "@ryde/shared";

import { RidesCalendarRowsFilterSelect } from "../calendar";
import {
  PanelTopRightRides,
  RidesKanbanSortDropdown,
  RidesPanelTopSettingsStyled,
  RidesPanelTopWrapper,
} from "./parts";

export const RidesPanelTop: FC = () => {
  const {
    isKanbanView,
    isGridSingleSelectView,
    isGridMultiSelectView,
    isRidesCalendarView,
  } = useRidesNavigation();
  const isRidesGridMultiSelectView = isGridMultiSelectView;
  const { isMobile } = useIsMobile();
  const systemParams = useRecoilValue(systemSettingsDtoAtom);
  const showToggleMapButton = useMemo(() => {
    return !isKanbanView && !isMobile;
  }, [isKanbanView, isMobile]);

  return (
    <RidesPanelTopWrapper>
      <RidesPanelTopSettingsStyled>
        <div className="left_controls">
          {isRidesCalendarView && <RidesCalendarRowsFilterSelect />}
          {!isGridSingleSelectView && !isRidesCalendarView && (
            <RidesSelectAllCheckbox
              enableSelectRows={isRidesGridMultiSelectView}
              enableSelectionMenu={isRidesGridMultiSelectView}
            />
          )}
          {isKanbanView && <RidesKanbanSortDropdown />}
          {systemParams?.metadata?.allowDockStations && (
            <RidesAssignDocksButton />
          )}
          {showToggleMapButton && <RidesMapToggleButton />}
          <RidesNearByButton />
        </div>
        <div className="right_stat_panel">
          <PanelTopRightRides />
        </div>
      </RidesPanelTopSettingsStyled>
    </RidesPanelTopWrapper>
  );
};
